import React, { useEffect, useState, useRef } from 'react';
import ScopeCamera from '../../classes/Camera';
import Engine from '../../classes/Engine';
import { CustomEventTypes } from '../../globals';
import useEventListener from '../reactUtils/useEventListener';

export default function UIRenderedCanvas(props) 
{
	const cameraId = props.cameraId;
	const canvasRef = useRef(null);
	const [zoomed, setZoomed] = useState(false);
	const [, updateState] = React.useState();
	const forceUpdate = React.useCallback(() => updateState({}), []);
	let scopeCamera = getScopeCamera();
  
	useEffect(() => 
	{
		if(scopeCamera) 
		{
			console.log('toggling canvas update from react');
			scopeCamera.toggleUpdateCanvas(true);
			scopeCamera.onCameraAspectChanged = (aspect) => 
			{
				forceUpdate();
			};
		}

		// cleanup
		return () => 
		{
			if (scopeCamera) 
			{
				scopeCamera.toggleUpdateCanvas(false);
			}
		};
	}, [scopeCamera])

	useEventListener(CustomEventTypes.hierarchyChangedEvent, onHierarchyChanged, document);
	function onHierarchyChanged() 
	{
		const camera = getScopeCamera();
		if (camera) 
		{
			camera.toggleUpdateCanvas(true);
			scopeCamera = camera;
		}
	}

	//register to the camera rendered event
	useEventListener(CustomEventTypes.cameraRendered, handleCameraRendered, document);

	function handleCameraRendered(e) 
	{
		if (scopeCamera) 
		{
			if (e.detail.cameraId === cameraId) 
			{
				if (canvasRef && canvasRef.current) 
				{
					let context = canvasRef.current.getContext('2d');
					context.clearRect(0, 0, 10000, 10000); //clear before redrawing now that aspects can change dynamically
					context.drawImage(scopeCamera.canvas, 0, 0);
					context.globalCompositeOperation = "source-over";
					if (props.title) 
					{
						context.fillStyle = "#000000";
						context.fillRect(0, canvasRef.current.height - 50, canvasRef.current.width, 50);
						context.fillStyle = "#FFFFFF";
						context.font = '48px Arial';
						context.textBaseline = 'middle';
						context.textAlign = "center";
						context.fillText(props.title, canvasRef.current.width / 2, canvasRef.current.height - 25);
					}

					context.lineWidth = 5;
					context.strokeStyle = "#000000";
					context.strokeRect(0, 0, canvasRef.current.width, canvasRef.current.height);
				}
			}
		}
	}

	if (!scopeCamera) 
	{
		return [];
	}

	return (
		<>
			<canvas className={props.className}
				height={540}
				width={getScopeCamera().getCameraAspect() * 540}
				style={!zoomed ? { zIndex:props.zIndex, height: props.height + '%' } :
					{ zIndex:props.zIndex, height: '300%' }}
				ref={canvasRef}
				onClick={(e) => 
				{
					console.log('clicked');
					setZoomed(!zoomed);
				}}
                
			/>
		</>
	);

	function getScopeCamera() 
	{
		const cameras = ScopeCamera.getSceneCameras(Engine.getInstance().getCurrentScene());
		for (const camera of Object.values(cameras)) 
		{
			if (camera.userData.guid === cameraId) 
			{
				return camera;
			}
		}
		return null;
	}
}


